import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * send batch superbill to patient
 */
export default async function sendSuperbillToPatient(batchStatementNo: string) {
  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/batch_superbill/send/${batchStatementNo}`,
    {
      method: "POST",
    },
  );
  if (!response.ok) {
    throw new Error(getErrorDetail(await response.text()));
  }
}
